import React, { useEffect, useState } from 'react'
import { updateCurrentTabStatus, updateCurrentGenericTabStatus, getSelectedBotData } from '../../Redux/Actions/uiActions';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import history from '../../Routers/history';
import { SideMenuV5 } from 'react-ui-lib';
import './SideMenu.css';

import DASHBOAARDACTIVEICON from '../../../assets/icons/sideNavIcons/ic_robot_active.svg';
import DASHBOAARDICON from '../../../assets/icons/sideNavIcons/ic_robot.svg';
import TESTINGPAGEACTIVEICON from '../../../assets/icons/sideNavIcons/ic_testing_page_active.svg';
import TESTINGPAGEICON from '../../../assets/icons/sideNavIcons/ic_testing_page.svg';
import UISETTINGSACTIVEICON from '../../../assets/icons/sideNavIcons/ic_ui_settings_active.svg';
import UISETTINGSICON from '../../../assets/icons/sideNavIcons/ic_ui_settings.svg';
import MSGTEXTACTIVEICON from '../../../assets/icons/sideNavIcons/ic_message_active.svg';
import MSGTEXTICON from '../../../assets/icons/sideNavIcons/ic_message.svg';
import CARDSACTIVEICON from '../../../assets/icons/sideNavIcons/ic_card_active.svg';
import CARDSICON from '../../../assets/icons/sideNavIcons/ic_card.svg';
import IMAGESACTIVEICON from '../../../assets/icons/sideNavIcons/ic_image_active.svg';
import IMAGESICON from '../../../assets/icons/sideNavIcons/ic_image.svg';
import FRAMEWORKSACTIVEICON from '../../../assets/icons/sideNavIcons/ic_frameworks_active.svg';
import FRAMEWORKSICON from '../../../assets/icons/sideNavIcons/ic_frameworks.svg';
import JSACTIVEICON from '../../../assets/icons/sideNavIcons/ic_js_active.svg';
import JSICON from '../../../assets/icons/sideNavIcons/ic_js.svg';
import CSSACTIVEICON from '../../../assets/icons/sideNavIcons/ic_css_active.svg';
import CSSICON from '../../../assets/icons/sideNavIcons/ic_css.svg';
import LOGSACTIVEICON from '../../../assets/icons/sideNavIcons/ic_logs_active.svg';
import LOGSICON from '../../../assets/icons/sideNavIcons/ic_logs.svg';
import SETTINGSACTIVEICON from '../../../assets/icons/sideNavIcons/ic_botsettings_blue_active.svg';
import SETTINGSICON from '../../../assets/icons/sideNavIcons/ic_botsettings_grey.svg';
import EBLOGOBLACKICON from '../../../assets/icons/ic_eb_logo_black.svg';
import { hideSideNavArr } from '../../Utils';

function Sidemenu(props) {

  const {
    selectedBotId,
    isCustomBot,
    currentFirstParam,
    currentActiveTab,
    currentGenericActiveTab,

    updateCurrentTabStatus,
    updateCurrentGenericTabStatus,
    getSelectedBotData,
    availableBotList
  } = props;
  let currentActiveTabMenu = currentGenericActiveTab;
  try {
    if (!currentFirstParam) {
      let tempfirstParam = window.location.pathname.split('/')[1];
      currentActiveTabMenu = tempfirstParam === 'genericconfig' ? '/' + currentGenericActiveTab : '/' + currentActiveTab
    } else {
      currentActiveTabMenu = currentFirstParam === 'genericconfig' ? '/' + currentGenericActiveTab : '/' + currentActiveTab
    }
  } catch (e) { }
  const [firstParam, setFirstParam] = useState('');

  const botMenuObject = {
    uiConfigObj: {
      title: "UI Configuration",
      children: [
        {
          icon: DASHBOAARDICON,
          activeIcon: DASHBOAARDACTIVEICON,
          title: "Chatbot",
          route: "/chatbot",
          id: "chatbot",
        },
        {
          icon: TESTINGPAGEICON,
          activeIcon: TESTINGPAGEACTIVEICON,
          title: "Testing page settings",
          route: "/testingpagesettings",
          id: "testingpagesettings",
        },
        {
          icon: UISETTINGSICON,
          activeIcon: UISETTINGSACTIVEICON,
          title: "UI settings",
          route: "/uisettings",
          id: "uisettings",
        },
        {
          icon: MSGTEXTICON,
          activeIcon: MSGTEXTACTIVEICON,
          title: "Message settings",
          route: "/messagesettings",
          id: "messagesettings",
        },
        {
          icon: CARDSICON,
          activeIcon: CARDSACTIVEICON,
          title: "Cards",
          route: "/cards",
          id: "cards",
        },
        {
          icon: IMAGESICON,
          activeIcon: IMAGESACTIVEICON,
          title: "Images",
          route: "/images",
          id: "images",
        }
      ]
    },
    developerConfigObj: {
      title: "Dev",
      children: [
        {
          icon: FRAMEWORKSICON,
          activeIcon: FRAMEWORKSACTIVEICON,
          title: "Framework",
          route: "/framework",
          id: "framework",
        }, {
          icon: JSICON,
          activeIcon: JSACTIVEICON,
          title: "Custom JS",
          route: "/customjs",
          id: "customjs",
        }, {
          icon: CSSICON,
          activeIcon: CSSACTIVEICON,
          title: "Custom CSS",
          route: "/customcss",
          id: "customcss",
        },
      ]
    },
    settingsConfig: {
      title: "",
      children: [
        {
          icon: SETTINGSICON,
          activeIcon: SETTINGSACTIVEICON,
          title: "Settings",
          route: "/settings",
          id: "settings",
        }
      ],
    },
    otherConfigObj: {
      title: "",
      children: [
        {
          icon: LOGSICON,
          activeIcon: LOGSACTIVEICON,
          title: "Logs",
          route: "/logs",
          id: "logs",
        }
      ],
    },
  }

  const genericMenuObject = {
    uiConfigObj: {
      title: "UI Configuration",
      children: [
        {
          icon: UISETTINGSICON,
          activeIcon: UISETTINGSACTIVEICON,
          title: "UI settings",
          route: "/uisettings",
          id: "uisettings",
        },
        {
          icon: MSGTEXTICON,
          activeIcon: MSGTEXTACTIVEICON,
          title: "Message settings",
          route: "/messagesettings",
          id: "messagesettings",
        },
        {
          icon: CARDSICON,
          activeIcon: CARDSACTIVEICON,
          title: "Cards",
          route: "/cards",
          id: "cards",
        },
        {
          icon: IMAGESICON,
          activeIcon: IMAGESACTIVEICON,
          title: "Images",
          route: "/images",
          id: "images",
        }
      ]
    },
    developerConfigObj: {
      title: "Dev",
      children: [
        {
          icon: FRAMEWORKSICON,
          activeIcon: FRAMEWORKSACTIVEICON,
          title: "Framework",
          route: "/framework",
          id: "framework",
        }, {
          icon: JSICON,
          activeIcon: JSACTIVEICON,
          title: "Custom JS",
          route: "/customjs",
          id: "customjs",
        }, {
          icon: CSSICON,
          activeIcon: CSSACTIVEICON,
          title: "Custom CSS",
          route: "/customcss",
          id: "customcss",
        }
      ]
    },
    settingsConfig: {
      title: "",
      children: [
        {
          icon: SETTINGSICON,
          activeIcon: SETTINGSACTIVEICON,
          title: "Settings",
          route: "/settings",
          id: "settings",
        }
      ],
    },
  }

  const botMenuArray = [
    botMenuObject.uiConfigObj,
    botMenuObject.developerConfigObj,
    botMenuObject.settingsConfig,
    botMenuObject.otherConfigObj
  ];

  const genericMenuArray = [
    genericMenuObject.uiConfigObj,
    genericMenuObject.developerConfigObj,
    genericMenuObject.settingsConfig
  ];

  try {
    let tempfirstParam = window.location.pathname.split('/')[1];
    let tempLocation = window.location.pathname.split('/')[2];
    if (tempfirstParam !== firstParam) {
      setFirstParam(tempfirstParam);
    }
  } catch (e) { }

  useEffect(() => {
    if (currentFirstParam !== firstParam) {
      setFirstParam(currentFirstParam);
    }

    // if((firstParam !== 'genericconfig') && (firstParam !== 'bot-list')) {
    //   getSelectedBotData(firstParam);
    // }

  }, [firstParam]);

  const redirectUrl = (item) => {
    const url = item.route;
    const urlVal = item.id;
    if (firstParam === 'genericconfig') {
      updateCurrentGenericTabStatus(urlVal)
      history.push('/genericconfig' + url);
    } else if (isCustomBot) {
      updateCurrentTabStatus(urlVal);
      history.push('/' + selectedBotId + url);
    }
  }

  return (
    <div className='side-menu-container'>
      <SideMenuV5
        hideSideNav={hideSideNavArr.includes(window.location.pathname)}
        menu={((currentFirstParam === 'genericconfig' || firstParam === 'genericconfig') ? genericMenuArray : (isCustomBot ? botMenuArray : []))}
        location={currentActiveTabMenu}
        onClick={redirectUrl}
        logoUrl={currentActiveTabMenu}
        currentRoute={window.location.pathname}
        logo={
            <div className='d-inline-flex' style={{marginLeft: "15px"}}>
              <img src={EBLOGOBLACKICON} height="20" width="20" alt="enterpriseBot_logo"/>
              <div 
                style={{
                  fontSize: '18px',
                  fontWeight: '600',
                  lineHeight: '22px',
                  letterSpacing: '0em',
                  textAlign: 'left',
                  color: '#3C4147',
                  marginLeft: "8px"
                }}
              >
                BotForge
              </div>
            </div>
        }
    >
      {props.children}
    </SideMenuV5>
    </div>
  )
}


const mapStateToProps = state => {
  return {
    selectedBotId: state.UiReducer && state.UiReducer.selectedBotID ? state.UiReducer.selectedBotID : '',
    isCustomBot: state.UiReducer && state.UiReducer.isCustomBot ? state.UiReducer.isCustomBot : false,
    currentFirstParam: state.UiReducer && state.UiReducer.currentFirstParam ? state.UiReducer.currentFirstParam : undefined,
    currentActiveTab: state.UiReducer && state.UiReducer.currentActiveTab ? state.UiReducer.currentActiveTab : 'chatbot',
    currentGenericActiveTab: state.UiReducer && state.UiReducer.currentGenericActiveTab ? state.UiReducer.currentGenericActiveTab : 'uisettings',
    availableBotList: state?.UiReducer?.availableBotList || []
  };
};

const mapDispatchToProps = dispatch => {
  return bindActionCreators({
    updateCurrentTabStatus,
    updateCurrentGenericTabStatus,
    getSelectedBotData
  },
    dispatch
  );
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Sidemenu);